import { Keyboard } from 'lucide-react';

import { Modal } from '../components/Modal';
import { useUiStore } from '../stores/uiStore';
import styles from './HotkeyHelp.module.css';

const HOTKEYS: readonly { readonly keys: string; readonly description: string }[] = [
  { keys: 'C', description: 'Создать задачу' },
  { keys: '/', description: 'Фокус в поиск' },
  { keys: 'B', description: 'Доска проекта' },
  { keys: 'G', description: 'Бэклог проекта' },
  { keys: 'M', description: 'Моя доска' },
  { keys: 'Esc', description: 'Закрыть панель задачи' },
  { keys: '?', description: 'Эта шпаргалка' },
  { keys: 'Cmd + Enter', description: 'Отправить комментарий или описание' },
  { keys: '← / →', description: 'Фокус по карточкам доски' },
  { keys: 'Space', description: 'Взять карточку (drag-and-drop)' },
];

/** Шпаргалка по горячим клавишам (docs/06 §5.3). */
export function HotkeyHelp() {
  const isOpen = useUiStore((state) => state.isHotkeyHelpOpen);
  const setOpen = useUiStore((state) => state.setHotkeyHelpOpen);

  return (
    <Modal open={isOpen} onClose={() => setOpen(false)} title="Горячие клавиши">
      <div className={styles['head']}>
        <Keyboard aria-hidden size={18} />
        <p>Работают вне полей ввода. Esc закрывает любую панель.</p>
      </div>
      <dl className={styles['list']}>
        {HOTKEYS.map((item) => (
          <div key={item.keys} className={styles['row']}>
            <dt>
              <kbd>{item.keys}</kbd>
            </dt>
            <dd>{item.description}</dd>
          </div>
        ))}
      </dl>
    </Modal>
  );
}
